import { z } from "zod";

export const postSubscriptionsResolverSchema = z.object({
	message: z.string(),
});